<div *ngIf="isMobile; else desktopView" class="mobile-block">
    <div class="mobile-box">
        <div class="icon">📱</div>
        <p class="title">
            {{ 'mobile_title' | translate }}
        </p>
        <p class="subtitle">
            {{ 'mobile_subtitle' | translate }}
        </p>
        <p class="note">
            {{ 'mobile_note' | translate }}
        </p>
    </div>
</div>

<ng-template #desktopView>
    <div *ngIf="!isManufacturer && !(hideNavbar | async)">
        <app-nav-bar></app-nav-bar>
    </div>

    <div *ngIf="loaderService.isLoading() || loadingRouteConfig" class="loading">
        <div class="spinner-border"></div>
    </div>

    <div class="page-wrapper" [class.topbar-120]="!isManufacturer && !(hideNavbar | async)">
        <router-outlet (activate)="onActivate()"></router-outlet>
    </div>

    <app-login-popup></app-login-popup>
    <app-flash-message></app-flash-message>

    <div *ngIf="!isManufacturer && !(hideNavbar | async)">
        <app-footer></app-footer>
    </div>
</ng-template>




<!-- <div *ngIf="!isMobile && !isManufacturer && !(hideNavbar | async)">
    <app-nav-bar></app-nav-bar>
</div>

<div *ngIf="isMobile">
    <app-mobile-header></app-mobile-header>
</div>

<div *ngIf="loaderService.isLoading() || loadingRouteConfig" class="loading">
    <div class="spinner-border"></div>
</div>

<div class="page-wrapper" [class.topbar-120]="!isMobile && !isManufacturer && !(hideNavbar | async)"
    [class.mobile-page-wrapper]="isMobile">
    <router-outlet (activate)="onActivate()"></router-outlet>
</div>

<app-login-popup></app-login-popup>
<app-flash-message></app-flash-message>

<div *ngIf="isMobile">
    <app-mobile-bottom-navigation></app-mobile-bottom-navigation>
</div>

<div *ngIf="!isMobile && !isManufacturer && !(hideNavbar | async)">
    <app-footer></app-footer>
</div> -->